<template>
    <div name="init" class="page">
        <confirm-modal 
            v-if="isBackButton"
            @onClose="onBackConfirmNo"
            @onYes="onBackConfirmYes"
        />
        <common-modal 
            :title="'당뇨병 소모성재료 지원금은 직접 청구해 주세요'"
            :message="'2형 당뇨 위임 청구 서비스는 현재 준비 중입니다.<br>결제할 카드를 등록하여 전액 결제 후 직접 공단에 청구해 주세요.<br><br><br><br>'"
            :button1Text="'확인'"
            @onClose="() => {}"
            @onClickButton1="skip"
            :buttonCount="1"
            v-if="isCommonModal"
        />

        <div class="button-header">
            <img @click="back" style="width: 22px; cursor: pointer;" src="../../../assets/arrow_back.png" />
        </div>
        <steps 
            :step="2"
            :isStepper="false"
            :title="'복잡한 요양비 청구, 대신 해드릴게요'"
        />

        <div class="input-area">
            <!-- 초기 진입  -->
            <div>
                <span class="title">💡 왜 솔닥에 위임해야 할까요?</span>
                <div class="text-box">
                    <span style="font-weight: 600;">본인부담금만 바로 결제 가능!</span>
                    <span style="margin-top: 4px;">• 환급 절차 없이 본인부담금만 결제하세요</span>
                    <span>• 공단 지원금 혜택은 솔닥이 해결해드려요</span>
                </div>
                <div class="text-box">
                    <span style="font-weight: 600;">복잡한 청구 절차를 대신 처리!</span>
                    <span style="margin-top: 4px;">• 까다로운 공인인증서, 건강보험 홈페이지..
                        귀찮은 위임, 청구 등록까지 다 해드립니다</span>
                </div>
                <div class="text-box">
                    <span style="font-weight: 600;">필요한 건, 오직 신분증!</span>
                    <span style="margin-top: 4px;">• 위임장을 ‘작성하는 분'의 신분증을 준비해주세요</span>
                    <span style="color:#184FA1">(ex 주민등록증/운전면허증/외국인등록증)</span>
                </div>      
                <!-- next -->
                <bottom-button 
                    :text="'위임장 작성하기'"
                    :color="'var(--Gray-100, #1E1E1E)'"
                    @onClick="goContract"
                    style="margin-top: 40px;"
                />      
                <bottom-button 
                    :text="'나중에 하기'"
                    :color="'#FFF'"
                    @onClick="skip"
                    style="margin-top: 8px;"
                />    
            </div>
         
        </div>
    </div>

</template>

<script>
import Steps from '@/components/molecules/Steps'
import TextLabel from '@/components/atoms/TextLabel';
import {mapState} from 'vuex';
import BottomButton from '@/components/atoms/BottomButton';
import PageFooter from '@/components/molecules/PageFooter';
import Constant from '@/constant';
import ErrorModal from '@/components/modals/ErrorModal';
import Loading from '@/components/molecules/Loading';
import ConfirmModal from '@/components/modals/ConfirmModal';
import CommonModal from '@/components/modals/CommonModal';

export default {
    name: 'init',
    computed: mapState(['draftProfile', 'pre_delegation_info']),
    props: ['duplicateDelegation'],
    data: function()
    {
        return {
            isCommonModal: false,
            isBackButton: false
        }
    },
    mounted: function()
    {

        if(this.draftProfile.diabetes_type === 'TYPE2')
        {   

            this.isCommonModal = true;
            
            // modal
            // this.skip();
        }
    },
    components: {
        Steps,
        TextLabel,
        BottomButton,
        PageFooter,
        Loading,
        ErrorModal,
        ConfirmModal,
        CommonModal
    },
    methods: {
        onBackConfirmYes: function()
        {
            // 모든 state, file 초기화, request 초기화 
            this.$store.commit(Constant.INITIALIZE_DELEGATE_WITH_ADDITION);
            this.$router.push('/apply')
        },
        onBackConfirmNo: function()
        {
            this.isBackButton = false
        },

        convertDate: function(date)
        {   
            return `${date.substring(0, 4)}년 ${date.substring(5, 7)}월 ${date.substring(8, 10)}일`;
        },
        goContract: function()
        {
            this.$emit('goContract')
        },
        skip: function()
        {
            this.$router.push('/apply')
        },
        back: function()
        {
            this.isBackButton = true;

        }
    }
}
</script>

<style scoped>
    .page {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        box-sizing: border-box;
        position: relative;
        overflow-y: auto;
        height: 100dvh;
    }

    @media (min-width: 600px) {
        .page {
            width: 600px;
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-direction: column;
            box-sizing: border-box;
            overflow-y: auto;
            height: 100dvh;
        }
    }

    .button-header {
        width: 100%;
        height: 75px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 20.32px 15.5px;
        box-sizing: border-box;
        background: var(--Gray-20, #F3F5F8);
    }
    .input-area {
        width: 100%;
        padding: 40px 16px 30px 16px;
        border-bottom: 8px solid var(--Gray-sub-color1, #F3F5F8);
        box-sizing: border-box;
    }
    .title {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .text-box {
        width: 100%;
        flex-shrink: 0;
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        padding: 20px;
        margin-top: 16px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: -0.36px;
    }
    .text {
        color: #184FA1;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        letter-spacing: -0.36px;
        margin-top: 8px;
    }
    .label {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .text-red {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: -0.36px;
    }
    .text-normal {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: -0.36px;
    }
    .text-info {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: -0.42px;
        text-align: center;
    }
    .bold {
        color: #1E1E1E;
        text-align: center;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 18px; /* 128.571% */
        letter-spacing: -0.42px;
    }
    .text-bold {
        color: #184FA1;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 22px; /* 122.222% */
        margin-top: 8px;
    }
</style>


// WEBPACK FOOTER //
// src/components/organisms/revisit_contract/Init.vue